import { Stack } from '@mui/material'

import { OrdersGrid } from '@/components/OrdersGrid'
import { Navigo } from '@/components/Navigo'

import { Popup } from './Popup'

export function OrdersGridLayout() {
  return (
    <Stack width="100%" height="100%" overflow="hidden">
      <OrdersGrid />
      <Navigo />
      <Popup />
    </Stack>
  )
}
